import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export function trackViewItemList({
  currency,
  listName,
  viewedItems = [],
  count,
  searchTerm,
  searchMethod,
  resultsFilters,
  searchType,
}: {
  currency?: string;
  listName?: string;
  viewedItems?: Array<EcommerceCartItem>;
  count?: number;
  searchTerm?: string;
  searchMethod?: string;
  resultsFilters?: {
    category?: string;
    price?: {
      min: string;
      max: string;
    };
  };
  searchType?: string;
}) {
  if (!viewedItems?.length) return;
  const items = listName ? viewedItems.map(item => ({ ...item, item_list_name: listName })) : viewedItems;
  pushToDataLayer({
    event: 'view_item_list',
    count: count,
    search_term: searchTerm,
    search_type: searchType,
    method: searchMethod,
    filters: resultsFilters,
    ecommerce: {
      currency: currency || '(unknown)',
      items,
    },
  });
}
